const namespaced = true

const defaultState = () => {
  return {
    loading: true,
    vehicles: [],
    companyFilter: '',
    grid: 'row',
    page: 1,
    lastPage: 100,
    search: '',
    brands: [],
    models: [],
    modelDetails: [],
    edit: false,
    locationFilter: {},
    locations: [],
    multiFilter: [],
    selectedVehicles: [],
    groups: [],
    visibleColumns: [
      {
        name: 'UNIT',
        val: 'unit'
      },
      {
        name: 'VIN',
        val: 'vin'
      },
      {
        name: 'LOCATION',
        val: 'location'
      },
      {
        name: 'BRAND',
        val: 'brand'
      },
      {
        name: 'MODEL',
        val: 'model'
      },
      {
        name: 'MODEL YEAR',
        val: 'model_year'
      },
      {
        name: 'CLASS NAME',
        val: 'class_name'
      },
      {
        name: 'CONDITION',
        val: 'condition'
      },
      {
        name: 'MILEAGE',
        val: 'mileage'
      },
      {
        name: 'CLASS UTILIZATION',
        val: 'class_utilization'
      },
      {
        name: 'CLASS RPU',
        val: 'class_rpu'
      },
      {
        name: 'CLASS T&M',
        val: 'class_t_m'
      },
      {
        name: 'RPU - DEPR. ASSM.',
        value: 'diff_rpu_assumption'
      },
      {
        name: 'DEPRECIATION ASSUMPTION',
        val: 'depreciation_assumption'
      },
      {
        name: 'AUCTION VALUE',
        val: 'auction'
      },
      {
        name: 'ESTIMATED PAYOFF',
        val: 'payoff'
      },
      {
        name: 'ESTIMATED REV/LOSS',
        val: 'revenue'
      },
      {
        name: 'MONTHLY PAYMENT',
        val: 'monthly_payment'
      },
      {
        name: 'STATUS',
        val: 'status'
      }
    ],
    tagQ: [],
    statusQ: []
  }
}

const state = defaultState()
const actions = {}
const mutations = {
  SET_TAG_Q(state, tagQ) {
    state.tagQ = tagQ
  },
  SET_STATUS_Q(state, statusQ) {
    state.statusQ = statusQ
  },
  SET_VISIBLE_COLUMNS(state, visibleColumns) {
    state.visibleColumns = visibleColumns
  },
  resetState(state) {
    Object.assign(state, defaultState())
  },
  RESET_FILTER(state, reset) {
    state.multiFilter = []
    state.search = ''
    state.companyFilter = {}
    state.visibleColumns = [
        {
          name: 'UNIT',
          val: 'unit'
        },
        {
          name: 'VIN',
          val: 'vin'
        },
        {
          name: 'LOCATION',
          val: 'location'
        },
        {
          name: 'BRAND',
          val: 'brand'
        },
        {
          name: 'MODEL',
          val: 'model'
        },
        {
          name: 'MODEL YEAR',
          val: 'model_year'
        },
        {
          name: 'CLASS NAME',
          val: 'class_name'
        },
        {
          name: 'CONDITION',
          val: 'condition'
        },
        {
          name: 'MILEAGE',
          val: 'mileage'
        },
        {
          name: 'CLASS UTILIZATION',
          val: 'class_utilization'
        },
        {
          name: 'CLASS RPU',
          val: 'class_rpu'
        },
        {
          name: 'CLASS T&M',
          val: 'class_t_m'
        },
        {
          name: 'DEPRECIATION ASSUMPTION',
          val: 'depreciation_assumption'
        },
        {
          name: 'AUCTION VALUE',
          val: 'auction'
        },
        {
          name: 'ESTIMATED PAYOFF',
          val: 'payoff'
        },
        {
          name: 'ESTIMATED REV/LOSS',
          val: 'revenue'
        },
        {
          name: 'MONTHLY PAYMENT',
          val: 'monthly_payment'
        },
        {
          name: 'STATUS',
          val: 'status'
        }
      ]
  },
  SET_GROUPS(state, groups) {
    state.groups = groups
  },
  SET_MULTI_FILTER(state, multiFilter) {
    state.multiFilter = multiFilter
  },
  SET_LOCATION_FILTER(state, locationFilter) {
    state.locationFilter = locationFilter
  },
  REMOVE_MULTI_FILTER(state, index) {
    state.multiFilter.splice(index, 1)
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations
  },
  SET_VEHICLE_DETAILS(state, details) {
    state.modelDetails = details
  },
  SET_VEHICLE_MODELS(state, models) {
    state.models = models
  },
  SET_VEHICLE_BRANDS(state, brands) {
    state.brands = brands
  },
  SET_SEARCH(state, search) {
    state.search = search
  },
  SET_COMPANY_FILTER(state, companyFilter) {
    state.companyFilter = companyFilter
  },
  SET_GRID_TYPE(state, grid) {
    state.grid = grid
  },
  SET_VEHICLES(state, vehicles) {
    state.vehicles = vehicles
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_VEHICLE_PAGE(state, page) {
    state.page = page
  },
  SET_PAGE(state, page) {
    state.page = page
  },
  SET_LAST_PAGE(state, lastPage) {
    state.lastPage = lastPage
  }
}
const getters = {
  getSelectedVehicle: state => state.selectedVehicle
}

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
